import { render, staticRenderFns } from "./Steppers.vue?vue&type=template&id=4bfd289c&scoped=true&"
import script from "./Steppers.vue?vue&type=script&lang=js&"
export * from "./Steppers.vue?vue&type=script&lang=js&"
import style0 from "./Steppers.vue?vue&type=style&index=0&id=4bfd289c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bfd289c",
  null
  
)

export default component.exports